// extracted by mini-css-extract-plugin
export var arrow = "_9-8";
export var fadeIn = "_9-1";
export var header = "_9-4";
export var image = "_9-3";
export var link = "_9-7";
export var modal = "_9-2";
export var overlay = "_9-0";
export var subtitle = "_9-6";
export var title = "_9-5";